import { Button, Checkbox, Label, Modal, TableSorting } from "components"
import { useState } from "react"
import { FaSliders } from "react-icons/fa6"
import { useToggle } from "utils"

export function FilterColumn(props: {
    dataFilter: TableSorting[]
    setTableActive: React.Dispatch<React.SetStateAction<TableSorting[]>>
}) {
    const { isActive, toggle } = useToggle(false)

    return (
        <div>
            <button>
                <FaSliders className="w-6 h-6 text-warning" onClick={toggle} />
                {isActive &&
                    <ModalFillter
                        toggle={toggle}
                        dataFillter={props.dataFilter}
                        setTableActive={props.setTableActive}
                    />
                }
            </button>
        </div>
    )
}

function ModalFillter(props: {
    toggle: () => void
    dataFillter: TableSorting[]
    setTableActive: React.Dispatch<React.SetStateAction<TableSorting[]>>
}) {

    const [tempFilter, setTempFilter] = useState<TableSorting[]>(props.dataFillter);

    const handleCheckboxChange = (index: number, checked: boolean) => {
        const updated = tempFilter.map((item, i) =>
            i === index ? { ...item, isActive: checked } : item
        );
        setTempFilter(updated);
    };

    const handleApply = () => {
        props.setTableActive(tempFilter);
        props.toggle();
    };

    return (
        <Modal
            isOpen
            title="Filter Column"
            closeModal={props.toggle}
        >
            <Modal.Body>
                <div className="grid grid-cols-3 gap-2">
                    {tempFilter.map((item, key) => (
                        <div key={key} className="flex items-center gap-3">
                            <div>
                                <Checkbox
                                    value={item.isActive}
                                    onChange={(e) => handleCheckboxChange(key, e.currentTarget.checked)}
                                />
                            </div>
                            <div>
                                <Label>{item.title}</Label>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button color="warning" onClick={handleApply}>APPLY</Button>
            </Modal.Footer>
        </Modal>
    )
}